export const getLocationVSN = (locationId) => {
    switch (locationId) {
      case 'csu':
        return 'W08E';
      case 'neiu':
        return 'W08D';
      case 'nu':
        return 'W099';
      case 'uic':
        return 'W096';
      case 'big':
        return 'W0A0';
      default:
        return 'W08E';
    }
  };